import React, { useEffect } from 'react';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import authConfig from '../config/auth0';
import { validateRedirectUri, getRedirectUri } from '../utils/auth0-session';

interface Auth0ProviderWithNavigateProps {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate: React.FC<Auth0ProviderWithNavigateProps> = ({ children }) => {
  const navigate = useNavigate();
  
  // Get dynamic redirect URI
  const redirectUri = getRedirectUri();
  
  useEffect(() => {
    // Only validate in development, don't interfere with Auth0's operation
    if (import.meta.env.MODE === 'development') {
      validateRedirectUri(redirectUri);
    }
  }, [redirectUri]);

  const onRedirectCallback = (appState?: any) => {
    // Remove the code and state parameters from the URL
    const targetUrl = appState?.returnTo || '/order-fulfillment/operations-dashboard';
    navigate(targetUrl, { replace: true });
  };

  // Debug logging removed for production

  const auth0Config: Auth0ProviderOptions = {
    domain: authConfig.domain,
    clientId: authConfig.clientId,
    authorizationParams: {
      redirect_uri: redirectUri,
      audience: authConfig.audience,
      scope: authConfig.scope,
      // Only prompt for consent if not already granted
      // This prevents annoying repeated consent screens
    },
    onRedirectCallback,
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    // Allow iframe-based silent auth as fallback
    useRefreshTokensFallback: true,
  };

  return (
    <Auth0Provider {...auth0Config}>
      {children}
    </Auth0Provider>
  );
};